module.exports = __webpack_public_path__ + "static/pterafolk-fff8b7f3edeca4101ffaf2404b43de1a.png";